import type { FeatureModule } from "../types";

/**
 * Adapter / trunk settings live in the Settings panel (Settings.tsx).
 * No dedicated route.
 */
export const adaptersFeature: FeatureModule = {
  id: "adapters",
  path: "",
  label: "Adapters",
  nav: false,
};
